import { Response } from '../models/stock-summary-master.model';
import { AlternativeDetailCondition } from '../models/alternative-part-inquiry.model';
import { MockService } from '../../../core/services/mock.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@environment';
import { delay, map, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AlternativePartInquiryService {
  // 測試範例為了模擬資料查詢時間，實際開發不會用到
  delay: number = 1500;

  constructor(
    private readonly mockService: MockService,
    private readonly httpClient: HttpClient
  ) {}

  getAlternativeHeader(
    itemNumber: string, vendorItem: string, ouId: number
  ): Observable<Response> {
    let endpoint = `${environment.apiEndpoint}/alternative/header`;
    endpoint = this.mockService.parseApiEndpoint(
      endpoint,
      '/api/v1/item360/alternative.json'
    );
    if (environment.apiMock) {
      return this.httpClient.get<Response>(endpoint).pipe(
        map((data) => data),
        delay(this.delay)
      );
    }
    const body = { itemNumber: itemNumber, vendorItem: vendorItem, ouId: ouId };
    return this.httpClient.post<Response>(endpoint, body);
  }
  
  getAlternativeDetail(
    condition: AlternativeDetailCondition
  ): Observable<Response> {
    let endpoint = `${environment.apiEndpoint}/alternative/detail`;
    endpoint = this.mockService.parseApiEndpoint(
      endpoint,
      '/api/v1/item360/alternative-detail.json'
    );
    if (environment.apiMock) {
      return this.httpClient.get<Response>(endpoint).pipe(
        map((data) => data),
        delay(this.delay)
      );
    }
    return this.httpClient.post<Response>(endpoint, condition);
  }
}
